<template>
  <router-view />
</template>

<script>
export default {
  name: 'LayoutAuth',
  created () {
    this.$store.commit('resetConfigCount')
    this.$store.commit('configComplete', true)
  }
}
</script>
